export default "__VITE_ASSET__F03bSik1__"